import React, {Component} from 'react';
import _ from "lodash";
import formatValue from "../../../../../../../../../../Utils/ListUtils/FormatValue";
import {
    Bar,
    BarChart,
    CartesianGrid,
    Label,
    LabelList,
    Legend,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from "recharts";
import {chartColors} from "../../../../../../../../../../Utils/ChartUtils/chartColors";
import ScreenDesignerListHoc from "../../../../../../../../../../HocHelpers/ScreenDesignerListHoc";
import {ChartTitle} from "../../../../../../../../../../Utils/ChartUtils/ChartTitle";
import {
    transformData,
    findColor,
    getColumnType,
    getColumnTypeById, humanizeDuration, isAllDuration,
    isAllInteger, getColumnById, getColumn
} from "../../../../../../../../../../Utils/ChartUtils/chartUtils";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import FilterListIcon from '@material-ui/icons/FilterList';
import {multiLanguageValue} from "../../../../../../../../../JsonScreen/Utils/lib";

class BarRechart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            props: {
                axisX: {},
                axisY: {},
                axisTop: {},
                axisRight: {},
                axisBottom: {},
                axisLeft: {}
            }
        }
    }

    componentDidMount() {
        const {
            columns, chartProps = {}, pivotGeneratedColumns,
            data: {content} = {},
        } = this.props;
        const newCols = pivotGeneratedColumns.length ? pivotGeneratedColumns : columns;
        let newContent = transformData(content, newCols);
        this.setState({
            props: chartProps,
            columns: newCols,
            listData: newContent || [],
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            columns,
            pivotGeneratedColumns,
            chartProps = {},
            data: {content} = {},
            pivotData = []
        } = this.props;
        const {
            chartProps: prevChartProps = {},
            columns: prevColumns,
            pivotGeneratedColumns: prevPivotGeneratedColumns,
            data: {content: prevContent},
            pivotData: prevPivotData = [],
        } = prevProps;
        const currentCols = pivotGeneratedColumns.length ? pivotGeneratedColumns : columns;
        const prevCurrentCols = prevPivotGeneratedColumns.length ? prevPivotGeneratedColumns : prevColumns;
        let currentData = pivotData.length ? pivotData : content;
        let prevCurrentData = prevPivotData.length ? prevPivotData : prevContent;


        if (currentData !== prevCurrentData) {
            let newData = transformData(currentData, currentCols);
            this.setState({listData: newData})
        }

        if (currentCols !== prevCurrentCols) {
            let newData = transformData(currentData, currentCols);
            this.setState({listData: newData, columns: currentCols})
        }

        if (!_.isEmpty(chartProps) && chartProps !== prevChartProps) {
            this.setState({props: chartProps})
        }
    }

    onLineClick = (obj, name) => {
        console.log(obj, name)
    };

    render() {
        const {
            listData = [],
            columns = [],
            props: {
                indexBy,
                series = [],
                background,
                enableGridX,
                enableGridY,
                enableLabel,
                axisX: {
                    position: positionX,
                    enable: enableX,
                    interval: intervalX = 0,
                    tickRotation: tickRotationX,
                    tickSize: tickSizeX,
                    label: labelX,
                    labelOffset: labelOffsetX
                } = {},
                axisY: {
                    position: positionY,
                    enable: enableY,
                    interval: intervalY = 0,
                    tickRotation: tickRotationY,
                    tickSize: tickSizeY,
                    label: labelY,
                    labelOffset: labelOffsetY
                } = {},
                legend: {
                    enable: legendEnable,
                    position: legendPosition,
                    verticalAlign,
                    direction,
                    itemHeight,
                    itemWidth,
                    translateY,
                    translateX
                } = {},
            }
        } = this.state;
        const {
            label,
            chartProps: {
                showAdvancedFilter,
                hideTitle,
                title: {
                    styles: {
                        fontSize: {size, type} = {},
                        fontStyle,
                        fontWeight,
                        textDecoration,
                        textAlign,
                        color,
                        background: titleBackground
                    } = {}
                } = {}
            }
        } = this.props;
        return (
            <>
                <div style={{display: 'flex'}}>
                    <div style={{flexGrow: 1}}>
                        <ChartTitle
                            hideLabel={hideTitle}
                            size={size}
                            type={type}
                            fontWeight={fontWeight}
                            fontStyle={fontStyle}
                            textDecoration={textDecoration}
                            textAlign={textAlign}
                            title={label}
                            color={color}
                            background={titleBackground}
                        />
                    </div>
                    {showAdvancedFilter && (
                        <IconButton style={{padding: 2}} disabled>
                            <Icon style={{margin: 5}}>
                                <FilterListIcon/>
                            </Icon>
                        </IconButton>
                    )}
                </div>
                <ResponsiveContainer width={'99%'} height={'99%'}>
                    <BarChart
                        data={listData}
                        margin={{
                            top: 20, right: 30, left: 30, bottom: 60,
                        }}
                    >
                        <XAxis
                            hide={!enableX}
                            dataKey={indexBy}
                            orientation={positionX}
                            label={<Label
                                value={labelX}
                                position={positionX}
                                offset={parseInt(labelOffsetX || 0)}
                                angle={0}
                                style={{textAnchor: 'middle'}}
                            />}
                            interval={parseInt(intervalX)}
                            angle={tickRotationX}
                            tickSize={tickSizeX}
                            minTickGap={80}
                            tick={{fontSize: 12}}
                            textAnchor="end"
                            tickFormatter={(v) => {
                                return getColumnTypeById(columns, indexBy) === 'duration' ? humanizeDuration(v, getColumnById(columns, indexBy).format) :
                                    formatValue(v, isAllInteger(columns, indexBy) ? 'integer' : 'number', undefined)
                            }}
                        />
                        <YAxis
                            hide={!enableY}
                            tickFormatter={(v) => {
                                return isAllDuration(columns, indexBy) ? humanizeDuration(v, columns.filter((c) => c.type === 'duration')[0].format) :
                                    formatValue(v, isAllInteger(columns, indexBy) ? 'integer' : 'number', undefined)
                            }}
                            orientation={positionY}
                            label={<Label
                                value={labelY}
                                position={positionY}
                                offset={parseInt(labelOffsetY || 0)}
                                angle={-90}
                                style={{textAnchor: 'middle'}}
                            />}
                            interval={parseInt(intervalY)}
                            angle={tickRotationY}
                            tickSize={tickSizeY}
                            minTickGap={80}
                            tick={{fontSize: 12}}
                            textAnchor={positionY === 'right' ? 'start' : 'end'}

                        />
                        <CartesianGrid
                            strokeDasharray="3 3"
                            horizontal={enableGridX}
                            vertical={enableGridY}
                            fill={background}
                        />
                        <Tooltip
                            cursor={{fill: 'transparent'}}
                            isAnimationActive={false}
                            labelFormatter={(value) => {
                                return getColumnTypeById(columns, indexBy) === 'duration' ?
                                    humanizeDuration(value, getColumnById(columns, indexBy).format) :
                                    value
                            }}
                            formatter={(value, name) => {
                                return getColumnType(columns, name) === 'duration' ?
                                    humanizeDuration(value, getColumn(columns, name).format)
                                    : formatValue(value, getColumnType(columns, name), undefined)
                            }}
                        />
                        {legendEnable && (
                            <Legend
                                align={legendPosition}
                                verticalAlign={verticalAlign}
                                layout={direction}
                                height={parseInt(itemHeight)}
                                width={parseInt(itemWidth)}
                                wrapperStyle={{
                                    paddingLeft: translateX ? `${translateX}px` : 0,
                                    paddingTop: translateY ? `${translateY}px` : 0
                                }}
                            />
                        )}
                        {columns.map((c, i) => {
                            const customColor = findColor(series, c.name);
                            const multiLanguageLabel = multiLanguageValue(c.label, this.props.userLanguage)
                            if (c.name !== 'grandTotal' && c.name !== indexBy && !c.hidden) {
                                return (
                                    <Bar key={`${c.name}_${i}`}
                                         stackId={'a'}
                                         onClick={(obj) => this.onLineClick(obj, c.name)}
                                         dataKey={c.name}
                                         animationDuration={300}
                                         name={multiLanguageLabel}
                                         fill={customColor ? customColor : chartColors[i % chartColors.length]}>
                                        {enableLabel && (
                                            <LabelList
                                                formatter={(value) => {
                                                    return isAllDuration ? humanizeDuration(value, c.format) : formatValue(value, 'number', undefined)
                                                }}
                                                dataKey={c.name}
                                                position="center"/>
                                        )}
                                    </Bar>
                                )
                            }
                            return null
                        })}
                    </BarChart>
                </ResponsiveContainer>
            </>
        );
    }
}

export default ScreenDesignerListHoc(BarRechart)
